import React from 'react';
import { Typography, Container } from '@mui/material';

function ComputerLiteracy() {
  return (
    <Container>
      <Typography variant="h1" gutterBottom>
        Computer Literacy
      </Typography>
      <Typography variant="h2" gutterBottom>
        Setting Up a VPN
      </Typography>
      <Typography variant="body1" paragraph>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non maximus erat, et bibendum leo. Duis ut massa ante.
      </Typography>
      <Typography variant="h2" gutterBottom>
        Basic Concepts
      </Typography>
      <Typography variant="body1" paragraph>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non maximus erat, et bibendum leo. Duis ut massa ante.
      </Typography>
      <Typography variant="h2" gutterBottom>
        Advanced Topics
      </Typography>
      <Typography variant="body1" paragraph>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non maximus erat, et bibendum leo. Duis ut massa ante.
      </Typography>
    </Container>
  );
}

export default ComputerLiteracy;
